import React from 'react';
import { PawPrint } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const PetInsurance = () => {
  const { language } = useLanguage();

  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-white">
      <div className="container mx-auto px-4">
        <a 
          href="https://www.fetchpet.com/mypet?a=FC44360-2&utm_source=firstconnect&utm_medium=brokerportal&utm_campaign=firstconnect_email&c=firstconnect&p=firstconnect"
          target="_blank"
          rel="noopener noreferrer"
          className="block bg-white rounded-3xl shadow-2xl overflow-hidden hover:shadow-3xl transition-all duration-300 transform hover:-translate-y-1"
        >
          <div className="grid lg:grid-cols-2 items-center">
            {/* Left Content */}
            <div className="p-8 md:p-12 lg:p-16 space-y-6">
              <div className="inline-block bg-blue-100 p-4 rounded-2xl">
                <PawPrint className="w-12 h-12 text-blue-700" />
              </div>
              
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                {language === 'en' 
                  ? 'Did you know we offer pet insurance?'
                  : '¿Sabía que ofrecemos seguro para mascotas?'}
              </h2>
              
              <p className="text-lg text-gray-600 leading-relaxed">
                {language === 'en'
                  ? 'Protect your furry family members with comprehensive pet insurance coverage. Get peace of mind knowing your pets are covered for unexpected veterinary costs.'
                  : 'Proteja a los miembros peludos de su familia con una cobertura integral de seguro para mascotas. Tenga tranquilidad sabiendo que sus mascotas están cubiertas por costos veterinarios inesperados.'}
              </p>

              <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300">
                {language === 'en' ? 'Get Pet Insurance' : 'Obtener Seguro para Mascotas'}
                <span className="group-hover:translate-x-1 transition-transform">→</span>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative h-full min-h-[400px]">
              <img
                src="https://images.unsplash.com/photo-1628676348963-f88c671333f6"
                alt="Pet Insurance"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-white/80 to-transparent lg:from-white/20"></div>
            </div>
          </div>
        </a>
      </div>
    </section>
  );
};

export default PetInsurance;